const surveys = {};

surveys.convention = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al Convegno?",
    values: [],
    type: "radio",
    value: "",
  },
  previous: {
    label: "È la prima volta che partecipi ad un Convegno Deascuola?",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questo Convegno?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 4, label: "Social" },
      { value: 3, label: "NewsLetter" },
      { value: 2, label: "Passaparola" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  eventEvaluationLabel: "Sei soddisfatto/a dei seguenti aspetti?",
  speakers: {
    label: "Padronanza dei contenuti del relatore",
    values: [],
    type: "radio",
    value: "",
  },
  coveredTopics: {
    label: "Argomenti trattati",
    values: [],
    type: "radio",
    value: "",
  },
  organization: {
    label: "Organizzazione",
    values: [],
    type: "radio",
    value: "",
  },
  location: {
    label: "Location",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato spunti pratici da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  schedule: {
    label: "Come valuti gli interventi della mattina in plenaria?",
    items: [],
    type: "subitems",
  },
  laboratories: {
    label: "Sei soddisfatto dei seguenti laboratori?",
    items: [],
    type: "subitems",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  speakerQuestions: {
    label: `Hai una domanda per uno o più relatori?
    Specifica il nome del relatore.
    Nelle prossime settimane raccoglieremo gli spunti più interessanti che verranno approfonditi sul sito.`,
    type: "text",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

surveys.seminar = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al Seminario?",
    values: [],
    type: "radio",
    value: "",
  },
  previous: {
    label: "È la prima volta che partecipi ad un Seminario Deascuola?",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto a conoscenza di questo Seminario?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 1, label: "Dirigente/Referente formazione" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Hai trovato interessanti gli argomenti trattati?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato spunti pratici da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  analyze: {
    label: "Ti piacerebbe approfondire ulteriormente gli argomenti con altri incontri?",
    values: [],
    type: "radio",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  speakerQuestions: {
    label: `Hai una domanda per il relatore?
    Specifica il nome del relatore.
    Raccoglieremo gli spunti più interessanti che verranno approfonditi sul sito.`,
    type: "text",
    value: "",
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

surveys.webinar = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al Webinar?",
    values: [],
    type: "radio",
    value: "",
  },
  previous: {
    label: "È la prima volta che partecipi ad un Webinar Deascuola?",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questo Webinar?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 3, label: "NewsLetter" },
      { value: 4, label: "Social" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Hai trovato interessanti gli argomenti trattati?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato spunti e indicazioni utili?",
    values: [],
    type: "radio",
    value: "",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  analyze: {
    label: "Ti piacerebbe approfondire ulteriormente gli argomenti con altri incontri?",
    values: [],
    type: "radio",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  speakerQuestions: {
    label: `Hai una domanda per il relatore?
    Specifica il nome del relatore.
    Raccoglieremo gli spunti più interessanti che verranno approfonditi sul sito.`,
    type: "text",
    value: "",
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

// TODO: is "event_types": {"id":"online-course","name":"Corso Online"} that has "event_groups: {"id":56,"name":"Corso light"}"?
surveys["online-premium"] = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al corso?",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questo corso?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 1, label: "Dirigente/referente formazione" },
      { value: 4, label: "Social" },
      { value: 3, label: "NewsLetter" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  satisfy: {
    label: "Rispetto alle tue aspettative iniziali, sei soddisfatto/a del corso?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Ritieni ci sia stato un buon bilanciamento tra contenuti teorici e pratici?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato utili i materiali proposti da sperimentare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  learning: {
    label: "Ritieni di aver imparato tecniche, strumenti e metodologie da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  guided: {
    label:
      "Hai trovato utile il percorso guidato e i feedback del formatore per lo svolgimento delle attività individuali?",
    values: [],
    type: "radio",
    value: "",
  },
  forum: {
    label: "Hai trovato utile l’esperienza nel forum per la condivisione con il formatore ed i partecipanti?",
    values: [
      { value: 5, label: "Moltissimo" },
      { value: 4, label: "Molto" },
      { value: 3, label: "In parte" },
      { value: 2, label: "Poco" },
      { value: 1, label: "Molto poco" },
      { value: 0, label: "Mai usato" },
    ],
    type: "radio",
    value: "",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  suggest: {
    label: "Consiglieresti questo corso ad un/a collega?",
    values: [],
    type: "radio",
    value: "",
  },
  newTopic: {
    label: "Su quale altro argomento ti piacerebbe fare un corso?",
    type: "text",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

// TODO: is this "event_types": {"id":"online-course","name":"Corso Online"} that has "event_groups: {"id":55,"name":"Corso premium"}"?
surveys["online-light"] = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al corso? ",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questo corso?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 1, label: "Dirigente/Referente formazione" },
      { value: 4, label: "Social" },
      { value: 3, label: "NewsLetter" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  satisfy: {
    label: "Rispetto alle tue aspettative iniziali, sei soddisfatto/a del corso?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Ritieni ci sia stato un buon bilanciamento tra contenuti teorici e pratici?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato utili i materiali proposti da sperimentare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  learning: {
    label: "Ritieni di aver imparato tecniche, strumenti e metodologie da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  forum: {
    label: "Hai trovato utile l’esperienza nel forum?",
    values: [
      { value: 5, label: "Moltissimo" },
      { value: 4, label: "Molto" },
      { value: 3, label: "In parte" },
      { value: 2, label: "Poco" },
      { value: 1, label: "Molto poco" },
    ],
    type: "radio",
    value: "",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  suggest: {
    label: "Consiglieresti questo corso ad un/a collega?",
    values: [],
    type: "radio",
    value: "",
  },
  newTopic: {
    label: "Su quale altro argomento ti piacerebbe fare un corso?",
    type: "text",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

surveys.bundle = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al corso? ",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questo corso?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 1, label: "Dirigente/Referente formazione" },
      { value: 4, label: "Social" },
      { value: 3, label: "NewsLetter" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  satisfy: {
    label: "Rispetto alle tue aspettative iniziali, sei soddisfatto/a del corso?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Ritieni ci sia stato un buon bilanciamento tra contenuti teorici e pratici?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato utili i materiali proposti da sperimentare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  learning: {
    label: "Ritieni di aver imparato tecniche, strumenti e metodologie da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  forum: {
    label: "Hai trovato utile l’esperienza nel forum?",
    values: [
      { value: 5, label: "Moltissimo" },
      { value: 4, label: "Molto" },
      { value: 3, label: "In parte" },
      { value: 2, label: "Poco" },
      { value: 1, label: "Molto poco" },
    ],
    type: "radio",
    value: "",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  suggest: {
    label: "Consiglieresti questo corso ad un/a collega?",
    values: [],
    type: "radio",
    value: "",
  },
  newTopic: {
    label: "Su quale altro argomento ti piacerebbe fare un corso?",
    type: "text",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

surveys["customizable-course"] = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato al corso?",
    values: [],
    type: "radio",
    value: "",
  },
  previous: {
    label: "È la prima volta che partecipi ad un corso Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore/relatori?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato efficaci le metodologie didattiche utilizzate durante il corso?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Ritieni ci sia stato un buon bilanciamento tra contenuti teorici e pratici?",
    values: [],
    type: "radio",
    value: "",
  },
  support: {
    label: "È stata utile e di supporto l’assistenza ricevuta tramite mail da Deascuola Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  suggest: {
    label: "Sceglieresti ancora Deascuola Formazione per un nuovo corso di Formazione?",
    values: [],
    type: "radio",
    value: "",
  },
  newTopic: {
    label: "Su quale altro argomento ti piacerebbe fare un corso?",
    type: "text",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label:
      "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni di questo corso?",
    type: "text",
    value: "",
  },
};

surveys["video-lesson"] = {
  completed: false,
  general: {
    label: "Complessivamente, sei soddisfatto/a di aver partecipato alla Videolezione? ",
    values: [],
    type: "radio",
    value: "",
  },
  previous: {
    label: "È la prima volta che partecipi ad una Videolezione Deascuola?",
    values: [],
    type: "radio",
    value: "",
  },
  knowledge: {
    label: "Come sei venuto/a a conoscenza di questa Videolezione?",
    values: [
      { value: 6, label: "Agente" },
      { value: 5, label: "Sito Deascuola" },
      { value: 2, label: "Passaparola" },
      { value: 3, label: "NewsLetter" },
      { value: 0, label: "Altro", type: "text" },
    ],
    type: "radio",
    value: { text: "", value: null },
  },
  speakers: {
    label: "Sei soddisfatto/a della chiarezza espositiva e padronanza dei contenuti del relatore?",
    values: [],
    type: "radio",
    value: "",
  },
  topics: {
    label: "Hai trovato interessanti gli argomenti trattati?",
    values: [],
    type: "radio",
    value: "",
  },
  useful: {
    label: "Hai trovato spunti pratici da utilizzare in classe?",
    values: [],
    type: "radio",
    value: "",
  },
  analyze: {
    label: "Ti piacerebbe approfondire ulteriormente gli argomenti con altri incontri?",
    values: [],
    type: "radio",
    value: "",
  },
  reviews: {
    label:
      "Ti piacerebbe lasciare un commento/recensione sulla tua esperienza da condividere con i colleghi che non hanno avuto modo di partecipare?",
    type: "text",
    value: "",
  },
  authorization: {
    label:
      "Autorizzo a pubblicare il mio commento sul sito Deascuola Formazione e sui social. Lasciaci Nome, Cognome e Scuola di appartenenza",
    type: "checkbox",
    checked: false,
  },
  suggestions: {
    label: "Per noi la tua opinione è importante, hai suggerimenti per migliorare le prossime edizioni?",
    type: "text",
    value: "",
  },
};

export default surveys;
